// import axios from 'axios';
import recitals from "../data/schedule.json";
import seniors from "../data/seniors.json";

export default {
    recitals() {
        return recitals;
    },
    seniors() {
        return seniors;
    },
}